import { render, staticRenderFns } from "./TangiblesInput.vue?vue&type=template&id=0b3f0944&"
import script from "./TangiblesInput.vue?vue&type=script&lang=js&"
export * from "./TangiblesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports